import React, { useState, useEffect } from 'react';
import Api from "../../../services/api";
import "../../../assets/css/app/monetization.css";
import { useParams } from "react-router-dom";
import moment from 'moment';
import { toast } from 'react-toastify';
import { Spin } from 'antd';
import FilterCohost from "../../../components/filterCohost";
import Cohort_revenue from "./cohort_revenue";
import MonthCohost from "./month_cohost";
import FilterCohost2 from "../../../components/filterCohost2";
import { END_DATE, START_DATE } from '../../../utility';
import NoDataComponent from '../../../components/noData';
import ReChartComponentLine from '../../../components/chartLine';
import ColorCell from '../../../components/colorCell';
import { Popover, Menu, Button, Input, Checkbox, Modal, Tooltip, Tabs, Drawer } from 'antd';
import { 
    MoreOutlined, 
    ArrowUpOutlined, 
    ArrowDownOutlined, 
    PushpinOutlined,
    CheckOutlined,
    SearchOutlined,
    DownloadOutlined,
    FullscreenOutlined
} from '@ant-design/icons';
import * as XLSX from "xlsx-js-style";

const calculateGlobalMaxRetention = (data) => {
    if (!Array.isArray(data)) return 0;
    let globalMax = 0;
    data.forEach(item => {
        if (!item.retention) return;
        Object.values(item.retention).forEach(val => {
            const numVal = parseFloat(val);
            if (!isNaN(numVal)) {
                globalMax = Math.max(globalMax, numVal);
            }
        });
    });
    return globalMax;
};

const calculateGlobalMinRetention = (data) => {
    if (!Array.isArray(data)) return 0;
    let globalMin = 0;
    data.forEach(item => {
        if (!item.retention) return;
        Object.values(item.retention).forEach(val => {
            const numVal = parseFloat(val);
            if (!isNaN(numVal)) {
                globalMin = Math.min(globalMin, numVal);
            }
        });
    });
    return globalMin;
};

function AppCoHort(){
    const [loading, setLoading] = useState(true);
    const containerRef = React.useRef(null);
    const tableRef = React.useRef(null);

    const handleToggleFullscreen = React.useCallback(() => {
        const el = containerRef.current;
        if (!el) return;
        if (!document.fullscreenElement) {
            if (el.requestFullscreen) el.requestFullscreen();
        } else if (document.exitFullscreen) {
            document.exitFullscreen();
        }
    }, []);

    const handleExport = React.useCallback(() => {
        try {
            const tableEl = tableRef.current;
            if (!tableEl) return;
            const rgbToHex = (rgb) => {
                if (!rgb) return undefined;
                const m = rgb.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
                if (!m) return undefined;
                const r = Number(m[1]).toString(16).padStart(2, "0");
                const g = Number(m[2]).toString(16).padStart(2, "0");
                const b = Number(m[3]).toString(16).padStart(2, "0");
                return (r + g + b).toUpperCase();
            };

            const rows = tableEl.querySelectorAll("thead tr, tbody tr, tfoot tr");
            const ws = {};
            let maxC = 0;
            const grid = [];

            const setCell = (r, c, v, s, merge) => {
                const addr = XLSX.utils.encode_cell({ r, c });
                ws[addr] = { v: String(v ?? ""), t: "s" };
                if (s) ws[addr].s = s;
                if (merge) {
                    ws['!merges'] = ws['!merges'] || [];
                    ws['!merges'].push(merge);
                }
            };

            rows.forEach((tr, rIndex) => {
                grid[rIndex] = grid[rIndex] || [];
                let cIndex = 0;
                const cells = tr.querySelectorAll("th, td");
                cells.forEach((cellEl) => {
                    while (grid[rIndex][cIndex]) cIndex += 1;
                    const colspan = parseInt(cellEl.getAttribute("colspan") || "1", 10);
                    const rowspan = parseInt(cellEl.getAttribute("rowspan") || "1", 10);
                    let value = (cellEl.innerText || "").replace(/\u00A0/g, ' ').trim();
                    if (value === '') {
                        const dataValAttr = cellEl.getAttribute('data-export-value');
                        if (dataValAttr !== null) value = String(dataValAttr);
                    }
                    const cs = window.getComputedStyle(cellEl);
                    const bg = rgbToHex(cs.backgroundColor);
                    const color = rgbToHex(cs.color);
                    const style = {};
                    if (bg) style.fill = { patternType: "solid", fgColor: { rgb: bg } };
                    if (color) style.font = { color: { rgb: color } };

                    setCell(rIndex, cIndex, value, style, (colspan > 1 || rowspan > 1) ? {
                        s: { r: rIndex, c: cIndex },
                        e: { r: rIndex + rowspan - 1, c: cIndex + colspan - 1 },
                    } : undefined);

                    for (let r = 0; r < rowspan; r += 1) {
                        grid[rIndex + r] = grid[rIndex + r] || [];
                        for (let c = 0; c < colspan; c += 1) {
                            grid[rIndex + r][cIndex + c] = true;
                        }
                    }
                    cIndex += colspan;
                    if (cIndex > maxC) maxC = cIndex;
                });
            });
            ws['!ref'] = XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: rows.length - 1, c: maxC - 1 } });

            try {
                const headerRow = tableEl.querySelector('thead tr');
                if (headerRow) {
                    const ths = headerRow.querySelectorAll('th');
                    const cols = [];
                    let colIndex = 0;
                    ths.forEach((th) => {
                        const colspan = parseInt(th.getAttribute('colspan') || '1', 10);
                        const totalWidth = th.getBoundingClientRect().width || th.offsetWidth || 0;
                        const perCol = Math.max(30, Math.round(totalWidth / Math.max(1, colspan)));
                        for (let i = 0; i < colspan; i += 1) {
                            cols[colIndex] = { wpx: perCol };
                            colIndex += 1;
                        }
                    });
                    if (cols.length) ws['!cols'] = cols;
                }
            } catch (_) {}

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Data");
            XLSX.writeFile(wb, "cohort_report.xlsx");
        } catch (e) {
            console.error("Export failed:", e);
        }
    }, []);

    const [startDateTab1, setStartDateTab1] = useState(moment().subtract(START_DATE, 'days'));
    const [endDateTab1, setEndDateTab1] = useState(moment().subtract(END_DATE, 'days'));
    const [activeTab, setActiveTab] = useState('cohort');
    const [drawerOpen, setDrawerOpen] = useState(false);

    const [data,setData] = useState([]);
    const [dataTotal,setDataTotal] = useState([]);
    const [dataTotalD,setDataTotalD] = useState([]);
    const [filteredMetric,setFilteredMetric] = useState(null);

    const { code, os } = useParams();

    const [filterValuesTab1, setFilterValuesTab1] = useState(null);

    const [selectedButtonDimensions, setSelectedButtonDimensions] = useState(['date']);

    
    const [sortConfig, setSortConfig] = useState({ directions: {}, order: [] });
    const [pinnedColumns, setPinnedColumns] = useState({});
    const [leftPinnedOrder, setLeftPinnedOrder] = useState([]);
    const [openPopoverKey, setOpenPopoverKey] = useState(null);
    const [columnWidths, setColumnWidths] = useState({
        
        cost: 180,
        install_ad_network: 180,
        install_attributed: 180,
        ecpi_attributed: 180,
    });
    const [resizingState, setResizingState] = useState({
        activeKey: null,
        startX: 0,
        startWidth: 0,
    });

    const [chartData,setChartData] = useState({
        labels : [],
        datasets : []
    });

    const chartCountryOptions = {
        
        
    };

    const fetchDataTab1 = (filters) => {
        setLoading(true);


        const cleanedDimensionFilters = (filters?.dimensionFilters || [])
            .filter(f => f.key && f.value && f.value.length > 0)
            .map(f => ({ key: f.key, operator: f.operator, value: f.value }));

        const cleanedMetricFilters = (filters?.metricFilters || [])
            .filter(f => f.key && (f.min !== '' || f.max !== ''));


        const params = {
            code: code,
            os: os,
            from: filters?.startDate?.format('YYYY-MM-DD') || startDateTab1.format('YYYY-MM-DD'),
            to: filters?.endDate?.format('YYYY-MM-DD') || endDateTab1.format('YYYY-MM-DD'),
            selectedDimensions: Array.isArray(filters?.selectedDimensions) && filters.selectedDimensions.length > 0 ? filters.selectedDimensions : ['date']
        };

        if (filters?.sortKeys?.length > 0) {
            params.sortKeys = filters.sortKeys;
        }

        if (cleanedDimensionFilters.length > 0 || cleanedMetricFilters.length > 0) {
            params.filters = JSON.stringify({
                dimensionFilters: cleanedDimensionFilters,
                metricFilters: cleanedMetricFilters
            });
        }

        Api.get(`/api/app/cohort`, { params })
            .then(result => {
                if (result.data.code === 0) {
                    setData(result.data.data);
                    setDataTotal(result.data.data_total);
                    setDataTotalD(result.data.data_total_D);
                    setFilteredMetric(result.data.filtered_metric);
                } else {
                    toast.error("Lỗi lấy dữ liệu !!");
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                toast.error("Đã có lỗi xảy ra khi gọi API!");
            });
    };


    useEffect(() => {
        fetchDataTab1(filterValuesTab1);
    }, [code, os]);

    
    useEffect(() => {
        if (selectedButtonDimensions && selectedButtonDimensions.length > 0 && Object.keys(pinnedColumns).length === 0) {
            const first = selectedButtonDimensions[0] || 'date';
            setPinnedColumns({ [first]: 'left' });
            setLeftPinnedOrder([first]);
        }
        
    }, [selectedButtonDimensions]);


    const handleRunReportTab1 = (filters) => {
        setStartDateTab1(filters.startDate);
        setEndDateTab1(filters.endDate);
        setFilterValuesTab1(filters);
        setSelectedButtonDimensions(filters.selectedDimensions);
        fetchDataTab1(filters);
    };


    const formatNumber = (num, decimal = 2) => {
        const safeNum = Number(num);
        return isNaN(safeNum) ? '0' : safeNum.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: decimal });
    };

    const getRandomColor = () => {
        const letters = '0123456789ABCDEF';
        return '#' + Array.from({ length: 6 }, () => letters[Math.floor(Math.random() * 16)]).join('');
    };

    const getColumnWidth = (key) => {
        if (columnWidths[key]) return columnWidths[key];
        const col = columnMap[key];
        if (col && col.width) return col.width;
        
        
        if (typeof key === 'string' && /^D\d+$/.test(key)) return 100;
        return 150;
    };

    const toggleSort = (field) => {
        setSortConfig((prev) => {
            const next = { directions: { ...prev.directions }, order: [...prev.order] };
            if (next.directions[field]) {
                next.directions[field] = next.directions[field] === 'asc' ? 'desc' : 'asc';
            } else {
                next.directions[field] = 'asc';
                next.order = [field, ...next.order.filter(f => f !== field)];
            }
            return next;
        });
    };

    const clearSortField = (field) => {
        setSortConfig((prev) => {
            const next = { directions: { ...prev.directions }, order: prev.order.filter(f => f !== field) };
            delete next.directions[field];
            return next;
        });
    };

    const handlePinColumn = (columnKey, pinType) => {
        
        if (typeof columnKey === 'string' && /^D\d+$/.test(columnKey)) {
            return;
        }
        setPinnedColumns(prev => {
            const newPinned = { ...prev };
            if (pinType === 'none') {
                delete newPinned[columnKey];
            } else if (pinType === 'left') {
                newPinned[columnKey] = 'left';
            }
            return newPinned;
        });
        if (pinType === 'left') {
            setLeftPinnedOrder(prev => [columnKey, ...prev.filter(k => k !== columnKey)]);
            setOpenPopoverKey(null);
        } else if (pinType === 'none') {
            setLeftPinnedOrder(prev => prev.filter(k => k !== columnKey));
        }
    };

    const getColumnOrder = () => {
        const metricColumns = ['cost', 'install_ad_network', 'install_attributed', 'ecpi_attributed'];
        const hasAppVersion = selectedButtonDimensions.includes('app_version');
        const filteredMetricColumns = hasAppVersion 
            ? metricColumns.filter(col => !['cost', 'install_ad_network', 'ecpi_attributed'].includes(col))
            : metricColumns;
        return [...selectedButtonDimensions, ...filteredMetricColumns];
    };

    const getLeftOffset = (columnKey) => {
        
        const columnOrder = getColumnOrder();
        let offset = 0;
        for (const key of columnOrder) {
            if (key === columnKey) break;
            if (pinnedColumns[key] === 'left') {
                const col = columnMap[key];
                offset += col ? col.width : getColumnWidth(key);
            }
        }
        return offset;
    };

    

    const renderColumnMenu = (columnKey) => {
        const currentPin = pinnedColumns[columnKey] || 'none';
        const isSorted = !!sortConfig.directions[columnKey];
        const dir = sortConfig.directions[columnKey];
        
        const menuItems = [
            ...(dir !== 'asc' ? [{
                key: 'sort-asc',
                label: 'Sort Ascending',
                icon: <ArrowUpOutlined />,
                onClick: () => {
                    setSortConfig(prev => ({ directions: { ...prev.directions, [columnKey]: 'asc' }, order: [columnKey, ...prev.order.filter(f => f !== columnKey)] }));
                    setOpenPopoverKey(null);
                }
            }] : []),
            ...(dir !== 'desc' ? [{
                key: 'sort-desc',
                label: 'Sort Descending',
                icon: <ArrowDownOutlined />,
                onClick: () => {
                    setSortConfig(prev => ({ directions: { ...prev.directions, [columnKey]: 'desc' }, order: [columnKey, ...prev.order.filter(f => f !== columnKey)] }));
                    setOpenPopoverKey(null);
                }
            }] : []),
            ...(isSorted ? [{
                key: 'sort-clear',
                label: 'Clear Sort',
                icon: <ArrowUpOutlined rotate={90} />,
                onClick: () => { clearSortField(columnKey); setOpenPopoverKey(null); }
            }] : []),
            
            ...((typeof columnKey === 'string' && /^D\d+$/.test(columnKey)) ? [] : [{
                key: 'pin',
                label: 'Pin Column',
                icon: <PushpinOutlined />,
                children: [
                    {
                        key: 'pin-none',
                        label: 'No Pin',
                        icon: currentPin === 'none' ? <CheckOutlined /> : null,
                        onClick: () => handlePinColumn(columnKey, 'none')
                    },
                    {
                        key: 'pin-left',
                        label: 'Pin Left',
                        icon: currentPin === 'left' ? <CheckOutlined /> : null,
                        onClick: () => handlePinColumn(columnKey, 'left')
                    }
                ]
            }]),
            {
                type: 'divider'
            },
            {
                key: 'choose-columns',
                label: 'Choose Columns',
                onClick: () => { setChooseOpen(true); setOpenPopoverKey(null); }
            },
            {
                type: 'divider'
            },
            {
                key: 'reset-columns',
                label: 'Reset Columns',
                onClick: () => {
                    const firstCol = (selectedButtonDimensions && selectedButtonDimensions[0]) || 'date';
                    setPinnedColumns({ [firstCol]: 'left' });
                    setLeftPinnedOrder([firstCol]);
                    setColumnWidths({ cost: 180, install_ad_network: 180, install_attributed: 180, ecpi_attributed: 180 });
                    setSortConfig({ directions: {}, order: [] });
                    setHiddenColumns({});
                    setOpenPopoverKey(null);
                }
            }
        ];

        return (
            <Menu items={menuItems} style={{ borderInlineEnd: 'none' }} selectable={false} />
        );
    };

    
    const handleResizeStart = (e, columnKey) => {
        e.preventDefault();
        const currentWidth = getColumnWidth(columnKey);
        setResizingState({ activeKey: columnKey, startX: e.clientX, startWidth: currentWidth });
    };

    useEffect(() => {
        const onMouseMove = (e) => {
            if (!resizingState.activeKey) return;
            const delta = e.clientX - resizingState.startX;
            const newWidth = Math.max(100, resizingState.startWidth + delta);
            setColumnWidths(prev => ({ ...prev, [resizingState.activeKey]: newWidth }));
        };
        const onMouseUp = () => {
            if (resizingState.activeKey) {
                setResizingState({ activeKey: null, startX: 0, startWidth: 0 });
            }
        };
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        return () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
    }, [resizingState]);

    const sortedData = React.useMemo(() => {
        const hasSort = Object.keys(sortConfig.directions || {}).length > 0;
        if (!hasSort) return Array.isArray(data) ? data : [];

        const compareByField = (field, aVal, bVal) => {
            const direction = (sortConfig.directions[field] === 'asc' ? 1 : -1);
            const A = aVal ?? '';
            const B = bVal ?? '';
            if (field === 'date') {
                const na = new Date(A).getTime();
                const nb = new Date(B).getTime();
                return na > nb ? direction : na < nb ? -direction : 0;
            }
            const na = Number(A);
            const nb = Number(B);
            if (!Number.isNaN(na) && !Number.isNaN(nb)) {
                return na > nb ? direction : na < nb ? -direction : 0;
            }
            return String(A).localeCompare(String(B)) * direction;
        };

        const comparator = (a, b) => {
            for (const field of sortConfig.order) {
                const aVal = /^D\d+$/.test(field) ? (a.retention ? a.retention[field] : undefined) : a[field];
                const bVal = /^D\d+$/.test(field) ? (b.retention ? b.retention[field] : undefined) : b[field];
                const res = compareByField(field, aVal, bVal);
                if (res !== 0) return res;
            }
            return 0;
        };

        const sortRecursive = (items) => {
            return [...items]
                .sort(comparator)
                .map((item) => ({
                    ...item,
                    children: Array.isArray(item.children) ? sortRecursive(item.children) : [],
                }));
        };

        return sortRecursive(data);
    }, [data, sortConfig]);


    useEffect(() => {
        const rawDay = filterValuesTab1?.metricFilters?.[0]?.metric_day;
        const maxDay = Number(rawDay) || 30;

        const formattedData = (Array.isArray(data) ? data : []).map(item => {
            const label = selectedButtonDimensions.map(dim => item[dim]).join('-');

            const color = getRandomColor();

            const data = Array.from({ length: maxDay + 1 }, (_, i) => {
                const key = `D${i}`;
                const value = item.retention?.[key];
                return value !== null && value !== undefined ? parseFloat(value) : 0;
            });

            return {
                label,
                data,
                backgroundColor: `${color}33`,
                tension: 0.3,
                fill: true,
            };
        });

        const labels = Array.from({ length: maxDay + 1 }, (_, i) => `D${i}`);

        setChartData({
            labels,
            datasets: formattedData
        });
    }, [data, filterValuesTab1, selectedButtonDimensions]);

    const columnMap = {
        date: {
            label: "Date",
            className: "sticky-col-1",
            width: 200,
        },
        country: {
            label: "Country",
            className: "sticky-col-2",
            width: 200,
        },
        campaign_id: {
            label: "Campaign",
            className: "sticky-col-3",
            width: 200,
        },
        ad_set_id: {
            label: "Ad Group",
            className: "sticky-col-4",
            width: 200,
        },
        media_source: {
            label: "Ad Network",
            className: "sticky-col-5",
            width: 200,
        },
        app_version: {
            label: "App Version",
            className: "sticky-col-6",
            width: 200,
        },
        ad_group: {
            label: "Ad Group",
            className: "sticky-col-7",
            width: 200,
        },
        ad: {
            label: "Ad",
            className: "sticky-col-8",
            width: 200,
        },
    };

    const tableStyles = {
        borderCollapse: 'separate',
        borderSpacing: '0 0', 
        '& td': {
            border: 'none', 
            position: 'relative',
        },
        '& tr:not(:lastChild)': {
            marginBottom: '2px', 
        },
        '& .retentionCell': {
            border: 'none !important',
        },
        '& .stickyCol': {
            borderRight: '0.5px solid #e0e0e0', 
        }
    };

    const pinnedColumnStyles = `
        .pinned-left {
            position: sticky !important;
            left: 0;
            z-index: 10;
            background-color: #f8f9fa;
            border-right: 1px solid #dee2e6;
        }
        .pinned-cell {
            position: sticky !important;
            z-index: 5;
            background-color: #fff;
        }
        .pinned-header {
            position: sticky !important;
            z-index: 10;
            background-color: #f8f9fa;
        }
        th .ant-btn-text { opacity: 0.7; }
        th:hover .ant-btn-text { opacity: 1; }
        th { position: sticky; top: 0; background: #f8f9fa; overflow: visible; }
    `;

    const getPinnedZIndex = (key, isHeader) => {
        const base = isHeader ? 60 : 40;
        const mapping = {
            date: 100,
            cost: 95,
            install_ad_network: 90,
            install_attributed: 85,
            ecpi_attributed: 80,
        };
        if (mapping[key]) return mapping[key];
        return base;
    };

    
    const [hiddenColumns, setHiddenColumns] = useState({});
    const [chooseSearch, setChooseSearch] = useState("");
    const [chooseOpen, setChooseOpen] = useState(false);

    const allColumnsOrder = () => {
        const metricColumns = ['cost', 'install_ad_network', 'install_attributed', 'ecpi_attributed'];
        // Ẩn các cột cost, install_ad_network, ecpi_attributed khi có dimension app_version
        const hasAppVersion = selectedButtonDimensions.includes('app_version');
        const filteredMetricColumns = hasAppVersion 
            ? metricColumns.filter(col => !['cost', 'install_ad_network', 'ecpi_attributed'].includes(col))
            : metricColumns;
        return [...selectedButtonDimensions, ...filteredMetricColumns, ...retentionHeaders];
    };

    const isColumnVisible = (key) => {
        // Ẩn các cột cost, install_ad_network, ecpi_attributed khi có dimension app_version
        const hasAppVersion = selectedButtonDimensions.includes('app_version');
        if (hasAppVersion && ['cost', 'install_ad_network', 'ecpi_attributed'].includes(key)) {
            return false;
        }
        return hiddenColumns[key] !== true;
    };

    const rawDay = filterValuesTab1?.metricFilters?.[0]?.metric_day;
    const maxDay = Number(rawDay) || 30;
    const retentionHeaders = Array.from({ length: maxDay + 1 }, (_, i) => `D${i}`);
    
    const globalMaxRetention = React.useMemo(() => calculateGlobalMaxRetention(data), [data]);
    const globalMinRetention = React.useMemo(() => calculateGlobalMinRetention(data), [data]);

    const renderGroup = (items) => {
        const columnOrder = getColumnOrder();
        let stickyIndex = 1;

        return items.map((item, index) => {
            const rowKey = `${index}`;

            return (
                <React.Fragment key={rowKey}>
                    <tr style={{ backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafafa' }}>
                        {columnOrder.filter(isColumnVisible).map((key, idx) => {
                            const col = columnMap[key];
                            const isPinned = pinnedColumns[key];
                            let className = "";

                            if (col) {
                                
                                stickyIndex++;

                                let displayValue = '-';
                                if (key === 'campaign_id') {
                                    displayValue = (item.campaign_id && item.campaign_id !== '') ? item.campaign_id : 'Unknown';
                                } else if (key === 'ad_set_id') {
                                    displayValue = item.ad_set ?? '-';
                                } else {
                                    displayValue = item[key] ?? '-';
                                }

                                return (
                                    <td
                                        key={key}
                                        className={className}
                                        style={{ 
                                            width: `${getColumnWidth(key)}px`,
                                            position: isPinned ? 'sticky' : 'relative',
                                            left: isPinned === 'left' ? `${getLeftOffset(key)}px` : 'auto',
                                            right: 'auto',
                                            zIndex: isPinned ? (900 - idx) : Math.max(1, 39 - idx),
                                            backgroundColor: '#fff'
                                        }}
                                    >
                                        {displayValue}
                                    </td>
                                );
                            } else {
                                
                                className = "text-center";
                                if (isPinned === 'left') {
                                    stickyIndex++;
                                }

                                let displayValue = '';
                                switch (key) {
                                    case 'cost':
                                        displayValue = `$${item?.cost != null ? formatNumber(item.cost) : 0}`;
                                        break;
                                    case 'install_ad_network':
                                        displayValue = item?.install_ad_network != null ? formatNumber(item.install_ad_network) : 0;
                                        break;
                                    case 'install_attributed':
                                        displayValue = item?.install_attributed != null ? formatNumber(item.install_attributed) : 0;
                                        break;
                                    case 'ecpi_attributed':
                                        displayValue = `$${item?.ecpi_attributed != null ? formatNumber(item.ecpi_attributed, 3) : 0}`;
                                        break;
                                    default:
                                        displayValue = '-';
                                }

                                return (
                                    <td
                                        key={key}
                                        className={className}
                                        style={{ 
                                            width: `${getColumnWidth(key)}px`,
                                            position: isPinned ? 'sticky' : 'relative',
                                            left: isPinned === 'left' ? `${getLeftOffset(key)}px` : 'auto',
                                            right: 'auto',
                                            zIndex: isPinned ? (900 - idx) : Math.max(1, 39 - idx),
                                            backgroundColor: '#fff'
                                        }}
                                    >
                                        {displayValue}
                                    </td>
                                );
                            }
                        })}

                        {retentionHeaders.filter(isColumnVisible).map((key) => {
                            const value = item.retention?.[key];
                            let decimal;
                            if (filteredMetric && filteredMetric.includes('rpdau')) {
                                decimal = 3; 
                            } else if (filteredMetric === 'ltv' || filteredMetric === 'iap_ltv' || filteredMetric === 'ad_ltv') {
                                decimal = 3;
                            } else {
                                decimal = 2;
                            }

                            return (
                                <ColorCell 
                                    key={key}
                                    value={value}
                                    globalMaxValue={globalMaxRetention}
                                    globalMinValue={globalMinRetention}
                                    metricType={filteredMetric}
                                    formatConfig={METRIC_FORMATS[filteredMetric]}
                                    decimal={decimal}
                                />
                            );
                        })}
                    </tr>

                </React.Fragment>
            );
        });
    };

    const renderTableHead = () => {
        const columnOrder = getColumnOrder();
        let stickyIndex = 1;

        return (
            <thead className="thead-light">
            <tr>
                {columnOrder.filter(isColumnVisible).map((key, idx) => {
                    const col = columnMap[key];
                    const isPinned = pinnedColumns[key];
                    let className = "th-text-filter";

                    if (col) {
                        
                        stickyIndex++;
                    } else {
                        
                        className += " text-center";
                        if (isPinned === 'left') {
                            stickyIndex++;
                        }
                    }

                    const getColumnLabel = (key) => {
                        if (col) return col.label;
                        switch (key) {
                            case 'cost': return 'Cost';
                            case 'install_ad_network': return 'Ad Network Installs';
                            case 'install_attributed': return 'Attributed Installs';
                            case 'ecpi_attributed': return 'Attributed eCPI';
                            default: return key;
                        }
                    };

                    const getWidth = (key) => getColumnWidth(key);

                    
                    const topFiveBoost = idx === 0 ? 100 : (idx < 5 ? 80 : undefined);
                    return (
                        <th
                            key={key}
                            className={className}
                            style={{ 
                                width: `${getWidth(key)}px`, 
                                height: "50px",
                                position: 'sticky',
                                left: isPinned === 'left' ? `${getLeftOffset(key)}px` : 'auto',
                                right: 'auto',
                                zIndex: isPinned ? (2000 - idx) : Math.max(10, 1500 - idx),
                                backgroundColor: '#f8f9fa',
                                top: 0,
                                overflow: 'visible'
                            }}
                        >
                            <div style={{ position: 'relative', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', paddingRight: 22 }}>
                            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                                {getColumnLabel(key)}
                                {sortConfig.directions[key] && (
                                    <i
                                        className={`fa-solid ${
                                            sortConfig.directions[key] === 'asc' ? 'fa-arrow-up text-primary' : 'fa-arrow-down text-primary'
                                        }`}
                                        style={{ fontSize: 12 }}
                                    />
                                )}
                            </span>
                                <Popover
                                    content={renderColumnMenu(key)}
                                    trigger="click"
                                    placement="bottomRight"
                                    open={openPopoverKey === key}
                                    onOpenChange={(open) => setOpenPopoverKey(open ? key : null)}
                                >
                                    <Button
                                        type="text"
                                        size="small"
                                        icon={<MoreOutlined />}
                                        style={{ 
                                            padding: 0,
                                            height: 18,
                                            width: 18,
                                            minWidth: 'auto',
                                            position: 'absolute',
                                            right: 2,
                                            top: '50%',
                                            transform: 'translateY(-50%)'
                                        }}
                                    />
                                </Popover>
                                {/* resize handle */}
                                <span
                                    onMouseDown={(e) => handleResizeStart(e, key)}
                                    style={{ cursor: 'col-resize', width: 6, position: 'absolute', right: -3, top: 0, bottom: 0 }}
                                />
                            </div>
                        </th>
                    );
                })}
                {retentionHeaders.filter(isColumnVisible).map((day) => (
                    <th key={day} className="text-center th-text-filter" style={{ width: `${getColumnWidth(day)}px`, height: "50px", position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 15 }}>
                        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingRight: 22, gap: 6 }}>
                            <span>{day}</span>
                            {sortConfig.directions[day] && (
                                <i
                                    className={`fa-solid ${sortConfig.directions[day] === 'asc' ? 'fa-arrow-up text-primary' : 'fa-arrow-down text-primary'}`}
                                    style={{ fontSize: 12 }}
                                />
                            )}
                            <Popover
                                content={renderColumnMenu(day)}
                                trigger="click"
                                placement="bottomRight"
                                open={openPopoverKey === day}
                                onOpenChange={(open) => setOpenPopoverKey(open ? day : null)}
                            >
                                <Button
                                    type="text"
                                    size="small"
                                    icon={<MoreOutlined />}
                                    style={{ position: 'absolute', right: 2, top: '50%', transform: 'translateY(-50%)', height: 18, width: 18, padding: 0 }}
                                />
                            </Popover>
                            <span
                                onMouseDown={(e) => handleResizeStart(e, day)}
                                style={{ cursor: 'col-resize', width: 6, position: 'absolute', right: -3, top: 0, bottom: 0 }}
                            />
                        </div>
                    </th>
                ))}
            </tr>
            </thead>
        );
    };
    

    const renderFooterRow = () => {
        const columnOrder = getColumnOrder();
        let stickyIndex = 1;

        return (
            <tfoot>
            <tr className="table-secondary fw-bold" key="t-footer-1">
                        {columnOrder.filter(isColumnVisible).map((key, idx) => {
                    const col = columnMap[key];
                    const isPinned = pinnedColumns[key];
                    let className = "";

                    if (col) {
                        
                        stickyIndex++;

                        return (
                            <td
                                key={key}
                                className={className}
                                style={{ 
                                    width: `${getColumnWidth(key)}px`,
                                    position: 'sticky',
                                    left: isPinned === 'left' ? `${getLeftOffset(key)}px` : 'auto',
                                    right: 'auto',
                                    bottom: 0,
                                    zIndex: isPinned ? (950 - idx) : 50,
                                    backgroundColor: '#e9ecef'
                                }}
                            >
                                {key === columnOrder[0] ? 'Total' : ''}
                            </td>
                        );
                    } else {
                        
                        className = "text-center";
                        if (isPinned === 'left') {
                            stickyIndex++;
                        }

                        let displayValue = '';
                        switch (key) {
                            case 'cost':
                                displayValue = `$${formatNumber(dataTotal?.cost)}`;
                                break;
                            case 'install_ad_network':
                                displayValue = formatNumber(dataTotal?.install_ad_network);
                                break;
                            case 'install_attributed':
                                displayValue = formatNumber(dataTotal?.install_attributed);
                                break;
                            case 'ecpi_attributed':
                                displayValue = `$${formatNumber(dataTotal?.ecpi_attributed, 3)}`;
                                break;
                            default:
                                displayValue = '-';
                        }

                        return (
                            <td
                                key={key}
                                className={className}
                            style={{ 
                                    width: `${getColumnWidth(key)}px`,
                                    position: 'sticky',
                                    left: isPinned === 'left' ? `${getLeftOffset(key)}px` : 'auto',
                                    right: 'auto',
                                    bottom: 0,
                                    zIndex: isPinned ? (950 - idx) : 50,
                                    backgroundColor: '#e9ecef'
                                }}
                            >
                                {displayValue}
                            </td>
                        );
                    }
                })}
                {retentionHeaders.filter(isColumnVisible).map((day) => (
                    <td key={day} className="text-center" style={{ position: 'sticky', bottom: 0, zIndex: 50, backgroundColor: '#e9ecef' }}>
                        {formatMetricValue(dataTotalD?.[day], filteredMetric)}
                    </td>
                ))}
            </tr>
            </tfoot>
        );
    };

    const METRIC_FORMATS = {
        retention: {
            suffix: '%',
            prefix: ''
        },
        dau: {
            suffix: '',
            prefix: ''
        },
        install_ad_network: {
            suffix: '',
            prefix: ''
        },
        ecpi_ad_network: {
            suffix: '',
            prefix: '$'
        },
        playtime: {
            suffix: '',
            prefix: ''
        },
        count_session: {
            suffix: '',
            prefix: ''
        },
        roas: {
            suffix: '%',
            prefix: ''
        },
        roi: {
            suffix: '%',
            prefix: ''
        },
        daily_pu: {
            suffix: '',
            prefix: ''
        },
        paid_rate: {
            suffix: '%',
            prefix: ''
        },
        ltv: {
            suffix: '',
            prefix: '$'
        },
        iap_ltv: {
            suffix: '',
            prefix: '$'
        },
        ad_ltv: {
            suffix: '',
            prefix: '$'
        },
        ad_revenue: {
            suffix: '',
            prefix: '$'
        },
        iap_revenue: {
            suffix: '',
            prefix: '$'
        },
        revenue: {
            suffix: '',
            prefix: '$'
        },
        banner_ipdau: {
            suffix: '',
            prefix: ''
        },
        banner_rpdau: {
            suffix: '',
            prefix: '$'
        },
        reward_ipdau: {
            suffix: '',
            prefix: ''
        },
        reward_rpdau: {
            suffix: '',
            prefix: '$'
        },
        inter_ipdau: {
            suffix: '',
            prefix: ''
        },
        inter_rpdau: {
            suffix: '',
            prefix: '$'
        },
        appopen_ipdau: {
            suffix: '',
            prefix: ''
        },
        appopen_rpdau: {
            suffix: '',
            prefix: '$'
        }
    };

    const formatMetricValue = (value, metricType) => {
        if (value === null || value === undefined || value === '' || isNaN(value) || value === '0') {
            value = 0;
        }
        
        const formatConfig = METRIC_FORMATS[metricType] || {};
        let formattedNumber;
        if(metricType === 'ltv' || metricType === 'iap_ltv' || metricType === 'ad_ltv' || (metricType && metricType.includes('rpdau'))){
            formattedNumber = formatNumber(value, 3);
        } else if (metricType && metricType.includes('ipdau')) {
            formattedNumber = formatNumber(value, 2);
        } else {
            formattedNumber = formatNumber(value);
        }
        
        return `${formatConfig.prefix || ''}${formattedNumber}${formatConfig.suffix || ''}`;
    };

    return (
    <>
    <style>{pinnedColumnStyles}</style>
    <Modal
        open={chooseOpen}
        onCancel={() => setChooseOpen(false)}
        footer={null}
        title="Choose Columns"
        destroyOnClose
        width={320}
        zIndex={4000}
    >
        <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', background: '#fafafa', borderRadius: 6 }}>
                    <Checkbox
                        indeterminate={false}
                        checked={allColumnsOrder().every(isColumnVisible)}
                        onChange={(e)=>{
                            const checked = e.target.checked;
                            if (checked) {
                                setHiddenColumns({});
                            } else {
                                const hidden = {};
                                allColumnsOrder().forEach(k => hidden[k] = true);
                                setHiddenColumns(hidden);
                            }
                        }}
                        style={{ marginLeft: 2 }}
                    />
                </div>
                <Input
                    placeholder="Search fields..."
                    value={chooseSearch}
                    onChange={(e) => setChooseSearch(e.target.value)}
                    addonBefore={<SearchOutlined />}
                    style={{ flex: 1 }}
                />
            </div>
            <div style={{ maxHeight: 360, overflow: 'auto' }}>
                {allColumnsOrder()
                    .filter((key) => (String(key).toLowerCase()).includes(chooseSearch.toLowerCase()))
                    .map((key, idx) => (
                        <div key={`choose-${key}`} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', background: idx % 2 === 0 ? '#fafafa' : '#fafafa', borderRadius: 6, marginBottom: 6 }}>
                            <Checkbox
                                checked={isColumnVisible(key)}
                                onChange={(e) => setHiddenColumns(prev => ({ ...prev, [key]: !e.target.checked }))}
                            />
                            <span style={{ flex: 1 }}>{key}</span>
                        </div>
                    ))}
            </div>
        </div>
    </Modal>
    <div className='background-second-dashboard'>
        <section className="main__content-dashbard">
            <div className="container-fluid">
                <div className='card'>
                    <div className='card-body'>
                        <div className="mobile-search-toggle" style={{ 
                            display: 'none',
                            position: 'fixed',
                            bottom: '20px',
                            right: '20px',
                            zIndex: 1000
                        }}>
                            <Button
                                type="primary"
                                shape="circle"
                                icon={<SearchOutlined />}
                                onClick={() => setDrawerOpen(true)}
                                style={{
                                    borderRadius: '50%',
                                    width: '48px',
                                    height: '48px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                    position: 'relative'
                                }}
                            />
                        </div>

                        <Tabs
                            activeKey={activeTab}
                            onChange={setActiveTab}
                            items={[
                                {
                                    key: 'cohort',
                                    label: 'Cohort',
                                },
                                {
                                    key: 'revenue',
                                    label: 'Revenue Cohort',
                                },
                                {
                                    key: 'monthly',
                                    label: 'Monthly Cohort',
                                },
                            ]}
                        />
                        {activeTab === 'cohort' && (
                            <div>
                                <div className="detail-body">
                                    <div className="overview_content pd-20">

                                        <div className="mt-4">

                                            <div className="desktop-filter">
                                            <FilterCohost
                                                startDate={startDateTab1}
                                                endDate={endDateTab1}
                                                handleChangeDate={(e, picker) => {
                                                    setStartDateTab1(picker.startDate);
                                                    setEndDateTab1(picker.endDate);
                                                }}
                                                id="filter-tab1"
                                                onRunReport={(filters) => {
                                                    handleRunReportTab1(filters);
                                                    setDrawerOpen(false);
                                                }}
                                            />
                                            </div>

                                            <div className="chart" style={{ margin: "25px 0", position: 'relative' }}>
                                                <Spin spinning={loading} style={{ width: '100%' }}>
                                                    <ReChartComponentLine type="line" data={chartData} options={chartCountryOptions} />
                                                </Spin>
                                            </div>
                                            <div className="d-flex justify-content-end mb-2">
                                                <div className="me-2">
                                                    <Tooltip title="Export">
                                                        <Button type="dashed" icon={<DownloadOutlined />} onClick={handleExport} />
                                                    </Tooltip>
                                                </div>
                                                <div>
                                                    <Tooltip title="Full Screen">
                                                        <Button type="dashed" icon={<FullscreenOutlined />} onClick={handleToggleFullscreen} />
                                                    </Tooltip>
                                                </div>
                                            </div>
                                            <div className="table-wrapper" ref={containerRef}>
                                                <div style={{ overflowX: 'auto', position: 'relative', maxHeight: '600px', overflowY: 'auto', display: 'block' }}>
                                                    <Spin spinning={loading}>
                                                    <table ref={tableRef} className="table table-bordered table-hover tb-campaign-center tb-cohost" style={{...tableStyles, minWidth: '1000px', tableLayout: 'fixed' }}>
                                                        {renderTableHead()}
                                                        <tbody>
                                                        {sortedData.length > 0 ? (
                                                            renderGroup(sortedData)
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="16" className="text-center">
                                                                    <NoDataComponent />
                                                                </td>
                                                            </tr>
                                                        )}
                                                        </tbody>
                                                        {renderFooterRow()}
                                                    </table>
                                                    </Spin>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {activeTab === 'revenue' && (
                            <div className="detail-body">
                                <div className="overview_content pd-20">
                                    <Cohort_revenue />
                                </div>
                            </div>
                        )}
                        {activeTab === 'monthly' && (
                            <div className="detail-body">
                                <div className="overview_content pd-20">
                                    <MonthCohost />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    </div>
    {/* Mobile: Drawer with filters */}
    <Drawer
        title="Search Filters"
        placement="right"
        onClose={() => setDrawerOpen(false)}
        open={drawerOpen}
        width={320}
        className="mobile-filter-drawer"
        zIndex={2500}
    >
        {activeTab === 'cohort' && (
            <FilterCohost
                startDate={startDateTab1}
                endDate={endDateTab1}
                handleChangeDate={(e, picker) => {
                    setStartDateTab1(picker.startDate);
                    setEndDateTab1(picker.endDate);
                }}
                id="filter-tab1-drawer"
                onRunReport={(filters) => {
                    handleRunReportTab1(filters);
                    setDrawerOpen(false);
                }}
            />
        )}
        {activeTab === 'revenue' && (
            <FilterCohost2
                id="filter-tab2-drawer"
                onRunReport={() => setDrawerOpen(false)}
            />
        )}
        {activeTab === 'monthly' && (
            <FilterCohost2
                id="filter-tab3-drawer"
                onRunReport={() => setDrawerOpen(false)}
            />
        )}
    </Drawer>
    <style>{`
        @media (max-width: 768px) {
          .desktop-filter { display: none !important; }
          .mobile-search-toggle { display: block !important; }
          /* Drawer body padding on mobile */
          .mobile-filter-drawer .ant-drawer-body { padding: 10px !important; }
          .mobile-filter-drawer .drawer-date-dropdown { max-width: 100% !important; }
          .mobile-filter-drawer .drawer-date-dropdown .ant-picker-panels { flex-direction: column !important; }
          /* Ensure cohort line chart uses full width on mobile */
          .overview_content .chart { width: 100% !important; }
          .overview_content .chart > div { width: 100% !important; max-width: 100% !important; }
          .overview_content .chart canvas { width: 100% !important; height: auto !important; }
        }
        @media (min-width: 769px) {
          .mobile-search-toggle { display: none !important; }
          .desktop-filter { display: block !important; }
        }
    `}</style>
    </>
    );
}
export default AppCoHort;